module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fzjg"
    }
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', [_c('p', [_c('b', [_vm._v("序号：")]), _vm._v(" " + _vm._s(index + 1) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("分支机构名：")]), _vm._v(" " + _vm._s(item.FZJGM) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("所在地：")]), _vm._v(" " + _vm._s(item.SZD) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("许可证号：")]), _vm._v(" " + _vm._s(item.XKZH) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("设立时间：")]), _vm._v(" " + _vm._s(item.SLSJ) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("负责人：")]), _vm._v(" " + _vm._s(item.FZR) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("客户服务及投诉电话：")]), _vm._v(" " + _vm._s(item.TSDH) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("详细地址：")]), _vm._v(" " + _vm._s(item.XXDZ) + " ")]), _vm._v(" "), _c('p', [_c('b', [_vm._v("电子邮箱：")]), _vm._v(" " + _vm._s(item.DZYX) + " ")]), _vm._v(" "), (_vm.list.length > 1) ? _c('div', {
      staticClass: "line"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "margin-b"
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d370a9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/xxgs/nr/fzjg.vue
// module id = 824
// module chunks = 2